
<template>
	<div style="width:100%; height:100%; border:0px solid red;">
		<!-- 左侧菜单组件定义 -->
		<LeftMenu :key="MenuKey" :menuData="lftMenu.menus" :menuAct="lftMenu.menuAct" :titleShow="lftMenu.show" style="width:100%; height:100%; flex:1; overflow-x:hidden; overflow-y:auto;"></LeftMenu>
	</div>
</template>

<script>

import Vue from 'vue'
Vue.prototype.lftMenu={                //左侧菜单控制参数
		show: true,                    //显示/隐藏标志
		widthNormal: 180,              //正常宽度
		widthHide: 29,                 //隐藏宽度
		itemHeight: [40, 30],          //每一级菜单的高度
		menuAct: {capt: null},         //当前选中的菜单项
		menus: [],
};

import LeftMenu     from './cf/leftmenu'

Vue.prototype.getLangText=function(s){
	return LangText(s);
}
Vue.prototype.getImgTypeName=function(ty1){
	if( ty1==150 ) return 	LangText("贴纸");
	if( ty1==151 ) return 	LangText("插图");
	if( ty1==152 ) return 	LangText("背景");
	if( ty1==153 ) return 	LangText("花边");
	if( ty1==156 ) return 	LangText("二维码");
	if( ty1==157 ) return   LangText("人脸融合");
	if( ty1==158 ) return 	LangText("照片");
	if( ty1==159 ) return 	LangText("文字");
}
Vue.prototype.getPasterTypeName=function(ty2){
	if( ty2==160 ) return 	"";
	if( ty2==161 ) return 	LangText("帽子");
	if( ty2==162 ) return 	LangText("头发");
	if( ty2==163 ) return 	LangText("面具");
	if( ty2==164 ) return 	LangText("表情");
	if( ty2==165 ) return 	LangText("眼镜");
	if( ty2==166 ) return 	LangText("胡须");
	if( ty2==167 ) return 	LangText("嘴唇");
	if( ty2==168 ) return 	LangText("气泡");
	if( ty2==169 ) return 	LangText("更多");
}
/* 素材类型 */
Vue.prototype.dataImgType=[
	{ itemName:LangText("素材"),  itemValue:"", subItems:[] },
	{ itemName:LangText("贴纸"),  itemValue:"150",  subItems:[] },
	{ itemName:LangText("插图"),  itemValue:"151",  subItems:[] },
	{ itemName:LangText("背景"),  itemValue:"152",  subItems:[] },
	{ itemName:LangText("花边"),  itemValue:"153",  subItems:[] },
	{ itemName:LangText("照片"),  itemValue:"158",  subItems:[] },
];
Vue.prototype.dataPasterType=[
	{ itemName:LangText("所有"),  itemValue:"", subItems:[] },
	{ itemName:LangText("帽子"),  itemValue:"161",  subItems:[] },
	{ itemName:LangText("头发"),  itemValue:"162",  subItems:[] },
	{ itemName:LangText("面具"),  itemValue:"163",  subItems:[] },
	{ itemName:LangText("表情"),  itemValue:"164",  subItems:[] },
	{ itemName:LangText("眼镜"),  itemValue:"165",  subItems:[] },
	{ itemName:LangText("胡须"),  itemValue:"166",  subItems:[] },
	{ itemName:LangText("嘴唇"),  itemValue:"167",  subItems:[] },
	{ itemName:LangText("气泡"),  itemValue:"168",  subItems:[] },
	{ itemName:LangText("更多"),  itemValue:"169",  subItems:[] },
];
Vue.prototype.dataEquityLevel=[
	{ itemName:LangText("所有"), itemValue:"", subItems:[] },
	{ itemName:LangText("NOR"),  itemValue:"130",  subItems:[] },
	{ itemName:LangText("VIP"),  itemValue:"131",  subItems:[] },
	{ itemName:LangText("SVIP"), itemValue:"132",  subItems:[] },
];
Vue.prototype.dataPublish=[
	{ itemName:LangText("所有"),    itemValue:"", subItems:[] },
	{ itemName:LangText("草稿"),    itemValue:"180",  subItems:[] },
	{ itemName:LangText("已发布"),  itemValue:"181",  subItems:[] }
];
Vue.prototype.dataYESNO=[
	{ itemName:LangText("是"),      itemValue:"1",  subItems:[] },
	{ itemName:LangText("否"),      itemValue:"0",  subItems:[] }
];
Vue.prototype.dataDevSts=[
	{ itemName:LangText("所有"),    itemValue:"", subItems:[] },
	{ itemName:LangText("试用"),    itemValue:"120",  subItems:[] },
	{ itemName:LangText("正式"),    itemValue:"121",  subItems:[] }
];
Vue.prototype.dataRechargeSts=[
	{ itemName:LangText("所有"),    itemValue:"", subItems:[] },
	{ itemName:LangText("已执行"),  itemValue:"0",  subItems:[] },
	{ itemName:LangText("未执行"),  itemValue:"1",  subItems:[] }
];
Vue.prototype.dataAiType=[
	{ itemName:LangText("所有"),     itemValue:"", subItems:[] },
	{ itemName:LangText("人脸融合"), itemValue:"1",  subItems:[] },
	{ itemName:LangText("风格渲染"), itemValue:"2",  subItems:[] }
];
Vue.prototype.dataAuthType=[
	{ itemName:LangText("Ledv"),    itemValue:"110",  subItems:[] },
	{ itemName:LangText("Soft"),    itemValue:"111",  subItems:[] }
];
Vue.prototype.dataFonts=[
	{ itemName:LangText("Algerian"), 	 itemValue:"Algerian",  	subItems:[] },
	{ itemName:LangText("Impact"),    	 itemValue:"Impact",  		subItems:[] },
	{ itemName:LangText("Serif"),    	 itemValue:"Serif",  		subItems:[] },
	{ itemName:LangText("隶书"), 	     itemValue:"隶书",  	    subItems:[] },
	{ itemName:LangText("楷体"), 	     itemValue:"楷体",  	    subItems:[] },
];
Vue.prototype.dataWarnDays=[
	{ itemName:LangText("所有"),    itemValue:"",    subItems:[] },
	{ itemName:LangText("已过期"),  itemValue:"0",   subItems:[] },
	{ itemName:LangText("近7日将过期"),   itemValue:"7",   subItems:[] },
	{ itemName:LangText("近30日将过期"),   itemValue:"30",   subItems:[] },
];
Vue.prototype.aiTypes=[
	{ itemName:LangText("人脸融合"),  itemValue:"1",    subItems:[] },
	{ itemName:LangText("风格渲染"),  itemValue:"2",   subItems:[] },
	{ itemName:LangText("豆包AI"),    itemValue:"3",   subItems:[] },
];
Vue.prototype.sex=[
	{ itemName:LangText("男"),  itemValue:"1",    subItems:[] },
	{ itemName:LangText("女"),  itemValue:"2",    subItems:[] },
];
Vue.prototype.mult=[
	{ itemName:LangText("单人"),  itemValue:"1",    subItems:[] },
	{ itemName:LangText("多人"),  itemValue:"2",    subItems:[] },
];
Vue.prototype.aiResults=[
	{ itemName:LangText("成功"),  itemValue:"1",    subItems:[] },
	{ itemName:LangText("失败"),  itemValue:"0",    subItems:[] },
];

Vue.prototype.getListTextByValue=function( list, val )
{
	for( let i=0; i<list.length; i++ )
	{
		if( (list[i].itemValue+"")===(val+"") ) return list[i].itemName;
	}
	return "";
}

Vue.prototype.getCurrencyText=function( ty ){
	if( ty == 840 ) 	return LangText("USD");
	if( ty == 156 ) 	return LangText("RMB");
}
Vue.prototype.getRechargeSts=function( sts ){
	if( sts == 0 ) 	return LangText("已执行");
	if( sts == 1 ) 	return LangText("未执行");
}
Vue.prototype.getAutyTypeText=function( ty ){
	if( ty == 110 ) return LangText("Ledv");
	if( ty == 111 ) return LangText("Soft");
	return "";
}
Vue.prototype.getDevStsText=function( sts ){
	if( sts == 120 ) return LangText("试用");
	if( sts == 121 ) return LangText("正式");
	return "";
}
Vue.prototype.getEquityText=function( level ){
	if( level == 130 ) return LangText("NOR");
	if( level == 131 ) return LangText("VIP");
	if( level == 132 ) return LangText("SVIP");
	return "";
}
Vue.prototype.getAiTypeText=function( level ){
	if( level == 1 ) return LangText("人脸融合");
	if( level == 2 ) return LangText("风格渲染");
	return "";
}
Vue.prototype.getUpdStepText=function( sts ){
	if( sts == 140 ) return LangText("未通知");
	if( sts == 141 ) return LangText("已通知");
	if( sts == 142 ) return LangText("已下载");
	if( sts == 149 ) return LangText("已升级");
	return "";
}
Vue.prototype.getForceText=function( v ){
	if( v == 1 ) return LangText("是");
	if( v == 0 ) return LangText("否");
	return "";
}
Vue.prototype.getRefundStsText=function( v ){
	if( v == 0 ) return LangText("");
	if( v == 1 ) return LangText("成功");
	if( v == 2 ) return LangText("未知");
	if( v == 3 ) return LangText("失败");

	return "";
}
Vue.prototype.getErrorText=function( pErrCode ){
	console.log( pErrCode );
	if( pErrCode ==  200 ) return LangText("成功");
	if( pErrCode ==  401 ) return "Unauthorized";
	if( pErrCode ==  403 ) return "Forbidden";
	if( pErrCode ==  404 ) return "page / interface not found";
	if( pErrCode ==   -1 ) return LangText("服务器异常错误");
	if( pErrCode ==   -2 ) return LangText("处理失败");
	if( pErrCode ==   -3 ) return LangText("记录不存在");
	if( pErrCode ==   -4 ) return LangText("接口未定义");
	if( pErrCode == -101 ) return LangText("设备未注册");
	if( pErrCode == -102 ) return LangText("设备已注册");
	if( pErrCode == -103 ) return LangText("用户验证失败");
	if( pErrCode == -104 ) return LangText("应用/版本不存在");
	if( pErrCode == -105 ) return LangText("记录已存在");
	if( pErrCode == -201 ) return LangText("验证码错误");
	if( pErrCode == -203 ) return LangText("用户不存在");
	if( pErrCode == -204 ) return LangText("密码错误");
	if( pErrCode == -205 ) return LangText("无效的token");
	if( pErrCode == -219 ) return LangText("原密码错误");

	console.error( "未定义的错误码"+"["+pErrCode+"]" );
	return LangText("未定义的错误码")+"["+pErrCode+"]";
}
Vue.prototype.Fen2Yuan=function( v ){
	let s="";
	let v1=Math.floor(v / 100);
	let v2=v % 100;

	if( v2 < 10 )
		 s = v1 + ".0" + v2;
	else s = v1 + "." + v2;

	return s;
}

export default {
	name: 'MainMenu',
	components:{
		LeftMenu
	},
	data () {
		return {
			MenuKey: 0,
		}
	},
	watch:{

	},
	mounted: function(){
		document.title = LangText(gPrjName+"管理平台");

		if( this.login.userType=="" ) return;
		this.loadMenu();
	},
	computed:{

	},
	methods:{
		onResize: function(){

			this.childResize( this );
		},
		/* 左侧菜单点击响应事件 */
		onMenuClick: function( menu ){
			if( menu.path && 0 < menu.path.length )
			{
				this.login.curMenu = menu.path;

				if( menu.param != null )
					 this.$router.push( {path:menu.path, query:menu.param} );
				else this.$router.push( menu.path );
			}
			else alert(menu.cont+" "+menu.v);
		},
		loadMenu: function(){
			let h0=this.lftMenu.itemHeight[0];
			let h1=this.lftMenu.itemHeight[1];

			this.lftMenu.menus = [
				{ cont:LangText("系统"), h:h0, expand:0, subMenus:[], icon:"../static/aiphoto_images/lmenu_system.png" },
				{ cont:LangText("素材"), h:h0, expand:0, subMenus:[], icon:"../static/aiphoto_images/lmenu_source.png"    },
				{ cont:LangText("模板"), h:h0, expand:0, subMenus:[], icon:"../static/aiphoto_images/lmenu_template.png"    },
			];

			let curMenu=null;
			let mainIdx=0;

			// 系统
			curMenu = this.lftMenu.menus[mainIdx++];
			if( this.login.userType == 101 ) curMenu.subMenus.push( { cont:LangText("我的信息"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/compInfo", param:null } );
			curMenu.subMenus.push( { cont:LangText("我的设备"), v:50, h:h1, clk:this.onMenuClick, path:"/FrameBody/devList", param:null } );
			curMenu.subMenus.push( { cont:LangText("到期预警"), v:50, h:h1, clk:this.onMenuClick, path:"/FrameBody/validityWarn", param:null } );
			curMenu.subMenus.push( { cont:LangText("数据中心"), v:50, h:h1, clk:this.onMenuClick, path:"/FrameBody/DataCube", param:null } );
			curMenu.subMenus.push( { cont:LangText("升级管理"), v:50, h:h1, clk:this.onMenuClick, path:"/FrameBody/upgradeMgr", param:null } );
			curMenu.subMenus.push( { cont:LangText("拍照记录查询"), v:50, h:h1, clk:this.onMenuClick, path:"/FrameBody/photoList", param:null } );
			curMenu.subMenus.push( { cont:LangText("支付记录查询"), v:50, h:h1, clk:this.onMenuClick, path:"/FrameBody/payList", param:null } );

			if( this.login.userId == gPlatUserId )
			{
				curMenu.subMenus.push( { cont:LangText("续费管理"), v:50, h:h1, clk:this.onMenuClick, path:"/FrameBody/feeMgr", param:null } );
				curMenu.subMenus.push( { cont:LangText("版本管理"), v:50, h:h1, clk:this.onMenuClick, path:"/FrameBody/verMgr", param:null } );
			}

			// 资源
			curMenu = this.lftMenu.menus[mainIdx++];
			curMenu.subMenus.push( { cont:LangText("背景"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/routerMid", param:{ty:152, findCustRange:"1,2", path:"/FrameBody/SourceList"} } );
			curMenu.subMenus.push( { cont:LangText("插图"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/routerMid", param:{ty:151, findCustRange:"1,2", path:"/FrameBody/SourceList"} } );
			curMenu.subMenus.push( { cont:LangText("花边"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/routerMid", param:{ty:153, findCustRange:"1,2", path:"/FrameBody/SourceList"} } );
			curMenu.subMenus.push( { cont:LangText("贴纸"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/routerMid", param:{ty:150, findCustRange:"1,2", path:"/FrameBody/SourceList"} } );
			//curMenu.subMenus.push( { cont:LangText("AI底图"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/routerMid", param:{ty:157, findCustRange:"1,2", path:"/FrameBody/SourceList"} } );

			// 模板
			curMenu = this.lftMenu.menus[mainIdx++];
			curMenu.subMenus.push( { cont:LangText("模板类型"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/tmList",     param:{findCustRange:"1,2"} } );
			curMenu.subMenus.push( { cont:LangText("我的模板"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/TemplaList", param:{findPublish:181, findModelType:0, findCustRange:"1,2"} } );
			curMenu.subMenus.push( { cont:LangText("人脸融合底图"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/routerMid", param:{ty:157, findCustRange:"1,2", path:"/FrameBody/SourceList"} } );
			curMenu.subMenus.push( { cont:LangText("AI场景-单人"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/routerMid", param:{ mode:1, findCustRange:"1,2", path:"/FrameBody/aiScene"} } );
			curMenu.subMenus.push( { cont:LangText("AI场景-多人"), v:10, h:h1, clk:this.onMenuClick, path:"/FrameBody/routerMid", param:{ mode:2, findCustRange:"1,2", path:"/FrameBody/aiScene"} } );

			for( let i=this.lftMenu.menus.length-1; 0<=i; i-- )
			{
				if( this.lftMenu.menus[i].subMenus.length==0 ) this.lftMenu.menus.splice( i, 1 );
			}

			this.MenuKey++;
		},
	}
}

</script>

<style scoped>



</style>



// WEBPACK FOOTER //
// mainmenu.vue?603714eb